import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const getWalletsData = async (
    url: string,
    token: string
): Promise<AxiosResponse> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useWalletList = (): UseQueryResult<
    AxiosResponse<any>,
    unknown
> => {
    const { getToken } = useAuth();

    return useQuery('wallets', async () =>
        getWalletsData('/metadata/wallet', getToken())
    );
};
